/* eslint-disable no-param-reassign */
import { sleep } from 'utils';
import { translate } from 'utils/translate';

import * as c from './types';

let lastId = 0;

const addAlert = (TYPE, text, { selfDismiss, dismissible, alertType }) => {
  selfDismiss = selfDismiss === true ? 2500 : selfDismiss;
  return async (dispatch) => {
    lastId += 1;
    const id = lastId;
    dispatch({
      type: c.ALERT.ADD,
      payload: {
        text: translate(text),
        data: [],
        dismissible,
        alertType,
        type: TYPE,
        id,
      },
    });
    if (selfDismiss) {
      await sleep(selfDismiss / 1000);
      dispatch({ type: c.ALERT.DISMISS_BY_ID, payload: id });
    }
    return id;
  };
};

const defaultOptions = {
  dismissible: true,
  selfDismiss: true,
  alertType: null,
};

/**
 * Add success Alert
 *
 * @param text {string || [{type: string, content: string, href?: string}]} - text or array of elements to be shown in the alert components
 * @param options {{selfDismiss?: boolean, dismissible?: boolean, alertType?: string}} - alert options
 * @returns {function(*): number}
 */
export const addSuccess = (text, options = defaultOptions) =>
  addAlert(c.ALERT_TYPES.SUCCESS, text, options);

/**
 * Add warning Alert
 *
 * @param text {string || [{type: string, content: string, href?: string}]} - text or array of elements to be shown in the alert components
 * @param options {{selfDismiss?: boolean, dismissible?: boolean, alertType?: string}} - alert options
 * @returns {function(*): number}
 */
export const addWarning = (text, options = defaultOptions) =>
  addAlert(c.ALERT_TYPES.WARNING, text, options);

/**
 * Add error Alert
 *
 * @param text {string || [{type: string, content: string, href?: string}]} - text or array of elements to be shown in the alert components
 * @param options {{selfDismiss?: boolean, dismissible?: boolean, alertType?: string}} - alert options
 * @returns {function(*): number}
 */
export const addError = (text, options = defaultOptions) =>
  addAlert(c.ALERT_TYPES.ERROR, text, options);

/**
 * Add info Alert
 *
 * @param text {string || [{type: string, content: string, href?: string}]} - text or array of elements to be shown in the alert components
 * @param options {{selfDismiss?: boolean, dismissible?: boolean, alertType?: string}} - alert options
 * @returns {function(*): number}
 */
export const addInfo = (text, options = defaultOptions) =>
  addAlert(c.ALERT_TYPES.INFO, text, options);

/**
 *  Dismiss last Alert
 * @returns {{type: string}}
 */
export const dismissLast = () => ({ type: c.ALERT.DISMISS_LAST });

/**
 * Dismiss by alert id
 * @param id - alert id
 * @returns {{payload: *, type: string}}
 */
export const dismissById = (id) => ({
  type: c.ALERT.DISMISS_BY_ID,
  payload: id,
});

/**
 *  Dismiss by type
 * @param type
 * @returns {{payload: *, type: string}}
 */
export const dismissByType = (type) => ({
  type: c.ALERT.DISMISS_BY_TYPE,
  payload: type,
});

/**
 *  Dismiss by custom type
 * @param customType
 * @returns {{payload: *, type: string}}
 */
export const dismissByCustomType = (customType) => ({
  type: c.ALERT.DISMISS_BY_CUSTOM_TYPE,
  payload: customType,
});
export const dismissAll = () => ({ type: c.ALERT.DISMISS_ALL });
